/*
 * @Author: PanYunhong
 * @Date: 2022-07-08 13:14:14
 * @LastEditors: PanYunhong
 * @LastEditTime: 2023-04-24 15:00:00
 */
import {
  get, post, getRequest, postRequest,
} from '@/request/request';
import axios from 'axios';

/**
 *  污染源统计——餐饮
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const hotTableStatistics = (params:any) => postRequest('/hotspotGridController/hotTableStatistics', params);

/**
 *  热点网格期次明细查询
 * @param {any} params 参数
 * @returns {any} 结果
 */

export const queryInfoByIssue = (params:any) => postRequest('/hotspotGridController/queryInfoByIssue', params);

/**
 *  热点网格逐时列表
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const queryHotTable = (params:any) => postRequest('/hotspotGridController/queryHotTable', params);

/**
 *  热点网格逐时列表
 * @param {any} params 参数
 * @returns {any} 结果
 */
// export const queryAllCompany = ():any => getRequest('/hotspotGridController/queryAllCompany');
export const queryAllCompany = ():any => postRequest('/gaochun/airMap/companyList');

/**
 *  删除热点网格
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const deleteHotGrid = (params:any) => postRequest('/hotspotGridController/delete', params);
